export var ENTITY = "bankAccount";
export var REDUCER_KEY = "BANK_ACCOUNT";
export var BASE_PATH_ENTITY = "bankaccounts";
export var GENERATOR_PARAMS = {
    entity: ENTITY,
    reducerKey: REDUCER_KEY,
    basePathEntity: BASE_PATH_ENTITY,
    legacyGetDetail: true,
};
